var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53343 11.7756L15.4801 4.99757C15.6076 4.89111 15.7717 4.83548 15.9395 4.84179C16.1072 4.84811 16.2664 4.91591 16.3851 5.03165C16.5039 5.14739 16.5734 5.30253 16.5799 5.46609C16.5864 5.62964 16.5293 5.78956 16.4201 5.91388L10.4201 11.7626L16.4334 17.5399C16.5427 17.6642 16.5997 17.8241 16.5932 17.9877C16.5868 18.1513 16.5172 18.3064 16.3985 18.4221C16.2798 18.5379 16.1206 18.6057 15.9528 18.612C15.785 18.6183 15.621 18.5627 15.4934 18.4562L8.53343 11.7756Z",
    fill: "#5FD0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53245 11.7756L14.4791 4.99757C14.6066 4.89111 14.7707 4.83548 14.9385 4.84179C15.1063 4.84811 15.2654 4.91591 15.3842 5.03165C15.5029 5.14739 15.5724 5.30253 15.5789 5.46609C15.5854 5.62964 15.5283 5.78956 15.4191 5.91388L9.41912 11.7626L15.4325 17.5399C15.5417 17.6642 15.5988 17.8241 15.5923 17.9877C15.5858 18.1513 15.5162 18.3064 15.3975 18.4221C15.2788 18.5379 15.1196 18.6057 14.9518 18.612C14.784 18.6183 14.62 18.5627 14.4925 18.4562L7.53245 11.7756Z",
    fill: "#011E29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.d40bca7618e21b349f120315a26c9574.svg";
export { ForwardRef as ReactComponent };